import type { JsonTransactionContract } from "@core/ports/json-storage";
import { JsonWriteConflictError } from "@core/ports/json-storage";

import type { SqliteClient, SqliteOperation } from "./SqliteClient.ts";

export class SqliteTransaction implements JsonTransactionContract {
  public readonly __typeTag = "JsonTransactionContract";

  // @mutable
  private readonly operations: SqliteOperation[] = [];

  private readonly sqlite: SqliteClient;

  public constructor({ sqlite }: { readonly sqlite: SqliteClient }) {
    this.sqlite = sqlite;
  }

  public add(operation: SqliteOperation): void {
    this.operations.push(operation);
  }

  /**
   * @throws {JsonWriteConflictError} If any operation's condition fails.
   */
  public async commit(): Promise<void> {
    const { committed } = await this.sqlite.transact(this.operations);

    if (!committed) {
      throw new JsonWriteConflictError(
        "A write condition failed, so the transaction wrote nothing",
      );
    }
  }
}
